module.exports = __webpack_public_path__ + "static/media/station-management.abf98800.svg";